<template>
  <div class="d-flex py-1 pl-1">
    <div>
      <v-icon small :color="color">{{ icon }}</v-icon>
    </div>
    <div class="pl-2"><slot /></div>
  </div>  
</template>

<script>
  export default{
    props: {
      color: {
        type: String,
        default: 'grey'
      },
      icon: String,
    },
  }
</script>